<form
  class="popin dflex fdc"
  [class.reduced]="reduced"
  [formGroup]="form"
  [id]="'mail-form-' + emailData.id"
>
  @if (loader.getLoading()) {
    <app-loader></app-loader>
  }
  <div class="popin-head dflex fdc">
    <div class="dflex aic jcsb head">
      @if (form.get('subject')?.value) {
        <span class="title-subject">{{ form.get('subject')?.value }}</span>
      } @else {
        <span>{{ 'MAILPOPIN.TITLE' | translate }}</span>
      }
      <div class="btns-cont dflex">
        <button
          class="btn"
          [attr.aria-label]="'ICON_ACTION.MINIMIZE' | translate"
          (click)="toggleReduce()"
        >
          <span class="material-symbols-rounded" aria-hidden="true"
            >remove</span
          >
        </button>
        <button
          class="btn"
          [attr.aria-label]="'BUTTON.CLOSE' | translate"
          (click)="close()"
        >
          <span class="material-symbols-rounded" aria-hidden="true">close</span>
        </button>
      </div>
    </div>
    <div class="to dflex aic">
      {{ 'MAILPOPIN.TO' | translate }} : {{ email }}
    </div>
    <div class="subject dflex aic">
      <span>{{ 'MAILPOPIN.SUBJECT' | translate }}&nbsp;: </span>
      <input
        type="text"
        formControlName="subject"
        [disabled]="loader.getLoading()"
      />
    </div>
  </div>
  <div class="popin-content h100">
    <quill-editor
      class="w100 h100 fdc"
      style="display: flex"
      customToolbarPosition="bottom"
      [placeholder]="'MAILPOPIN.TEXTAREAPLACEHOLDER' | translate"
      (onContentChanged)="onContentChanged($event)"
      [debounceTime]="500"
      [readOnly]="loader.getLoading()"
    >
      <div quill-editor-toolbar>
        <!-- Quill injecte un SVG décoratif dans ces boutons : sans nom, le
             lecteur d'écran les annonce « bouton » sans dire lequel (RGAA 6.2 /
             11.1). `aria-label` leur donne un nom traduit ; `type="button"`
             évite une soumission du formulaire parent. -->
        <span class="ql-formats">
          <button
            type="button"
            class="ql-bold"
            [attr.aria-label]="'MAILPOPIN.FORMAT.BOLD' | translate"
          ></button>
          <button
            type="button"
            class="ql-italic"
            [attr.aria-label]="'MAILPOPIN.FORMAT.ITALIC' | translate"
          ></button>
          <button
            type="button"
            class="ql-underline"
            [attr.aria-label]="'MAILPOPIN.FORMAT.UNDERLINE' | translate"
          ></button>
          <select
            class="ql-size"
            [attr.aria-label]="'MAILPOPIN.FORMAT.SIZE' | translate"
          >
            <option value="small">
              {{ 'MAILPOPIN.TEXTSIZE.SMALL' | translate }}
            </option>
            <option selected>
              {{ 'MAILPOPIN.TEXTSIZE.NORMAL' | translate }}
            </option>
            <option value="large">
              {{ 'MAILPOPIN.TEXTSIZE.LARGE' | translate }}
            </option>
            <option value="huge">
              {{ 'MAILPOPIN.TEXTSIZE.HUGE' | translate }}
            </option>
          </select>
          <select
            class="ql-align"
            [attr.aria-label]="'MAILPOPIN.FORMAT.ALIGN' | translate"
          >
            <option selected></option>
            <option value="center"></option>
            <option value="right"></option>
            <option value="justify"></option>
          </select>
          <!-- <button class="ql-link"></button> -->
        </span>
      </div>
    </quill-editor>
  </div>
  <div class="popin-bottom">
    <div class="bottom dflex aic">
      <button
        class="hub-button"
        (click)="sendMail()"
        [disabled]="loader.getLoading()"
      >
        {{ 'MAILPOPIN.SEND' | translate }}
      </button>
      <div class="bottom-btns dflex jcsb w100">
        <div class="dflex">
          <!-- <button class="btn dflex aic jcc" (click)="addFile()">
            <span class="material-symbols-rounded rotate45">attach_file</span>
          </button> -->
          <div class="dflex checkbox-cont aic">
            <input
              type="checkbox"
              formControlName="copy"
              [id]="'mail-copy-' + emailData.id"
              [disabled]="loader.getLoading()"
            />
            <label [attr.for]="'mail-copy-' + emailData.id">{{
              'MAILPOPIN.COPY' | translate
            }}</label>
          </div>
        </div>
        <div class="dflex">
          <!-- <button class="btn dflex aic jcc" (click)="openOptions()">
          <span class="material-symbols-rounded">more_vert</span>
        </button>
        <button class="btn dflex aic jcc" (click)="deleteMessage()">
          <span class="material-symbols-rounded">delete</span>
        </button> -->
        </div>
      </div>
    </div>
  </div>
</form>
